<template>
  <div id="app" class="position-relative">
    <LandingBackgroundVideo v-if="$route.meta.uses_landing_background" />
    <div class="position-relative z-1">
      <RouterView />
    </div>
    <SessionTimeoutPrompt />
  </div>
</template>

<style>
body {
  overflow: hidden;
}
</style>
 
 
